export default __webpack_public_path__ + "static/media/fitness.05079f06.png";